import React, { ReactElement } from "react";

import { HStack, TableCellProps, Td, Text, Tooltip } from "@chakra-ui/react";

import { getAccessorValue } from "@/util/data";

import { ColumnDefinition, statusStyles } from "./types";

export interface DataTableCellProps<D> extends TableCellProps {
  item: D;
  columnDefinition: ColumnDefinition<D>;
}

export function DataTableCell<D>({
  item,
  columnDefinition,
  ...tdProps
}: DataTableCellProps<D>): ReactElement<any, any> | null {
  const tdValue = getAccessorValue(item, columnDefinition.accessor);

  if (React.isValidElement(tdValue) && tdValue.type === Td) {
    return tdValue;
  }

  // check if the tdValue is a string and a valid key of statusStyles
  const isValidStatus = typeof tdValue === "string" && tdValue in statusStyles;

  return (
    <Td {...tdProps} textAlign={columnDefinition.align} p={4}>
      {isValidStatus ? (
        <Tooltip
          openDelay={500}
          bg="white"
          color="black"
          py={2}
          px={3}
          hasArrow
          w={300}
          fontSize={12}
          placement="end-start"
          label={statusStyles[tdValue]?.description}
        >
          <HStack
            rounded="full"
            px={3}
            w="fit-content"
            fontWeight={600}
            py={2}
            fontSize={12}
            bg={statusStyles[tdValue]?.bg}
            color={statusStyles[tdValue]?.color}
          >
            <Text>{statusStyles[tdValue]?.text}</Text>
          </HStack>
        </Tooltip>
      ) : (
        tdValue
      )}
    </Td>
  );
}
